export enum EnComponentsView {
    CARDS = 'CARDS',
    PROCESS = 'PROCESS',
    FLASH = 'FLASH',
    GRID_OCORRENCIAS = 'GRID_OCORRENCIAS',
    HTML5 = 'HTML5',
    CUSTOM = 'CUSTOM' // Indica que é um módulo desenvolvido sob-medida, com código personalizado.
}
